export const layoutTypes = {
  UPDATE: 'UPDATE',
};
